import { render } from "./LayoutPadrao.vue?vue&type=template&id=6eb460b1&scoped=true"
import script from "./LayoutPadrao.vue?vue&type=script&lang=js"
export * from "./LayoutPadrao.vue?vue&type=script&lang=js"

import "./LayoutPadrao.vue?vue&type=style&index=0&id=6eb460b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb460b1"]])

export default __exports__